import React from 'react';
import { Box } from '@mui/material';
import { DAY_CELL_WIDTH, DAY_STEP } from '../helpers';

interface TodayColumnHighlightProps {
  todayIndex: number;
  top?: number | string;
  bottom?: number | string;
}

const TodayColumnHighlight: React.FC<TodayColumnHighlightProps> = ({ todayIndex, top = '5px', bottom = '1px' }) => {
  if (todayIndex < 0) return null;
  return (
    <Box
      sx={{
        position: 'absolute',
        top,
        bottom,
        left: todayIndex * DAY_STEP,
        width: DAY_CELL_WIDTH,
        bgcolor: 'primary.main',
        opacity: 0.08,
        pointerEvents: 'none',
        zIndex: 0,
      }}
    />
  );
};

export default React.memo(TodayColumnHighlight);
